<template>
  <div
    v-if="slideType"
    class="justify-center aha-slide-type-icon"
    :class="{'items-center': !leftSide, 'aha-slide-type-icon-left': leftSide}"
  >
    <div
      class="aha-icon-slide-wrapper"
    >
      <aha-icon
        v-if="isNewTypeAnswerIcon"
        :name="slideTypeData.ahaIconTest"
        :maintainColor="true"
      />
      <aha-icon
        v-else-if="isNewTypeAnswerIconWhite"
        :name="slideTypeData.ahaIconTestWhite"
        :maintainColor="true"
      />
      <aha-icon
        v-else-if="slideTypeData.ahaIcon && isColorDark"
        :name="slideTypeData.ahaIcon"
        :maintainColor="true"
      />
      <aha-icon
        v-else-if="slideTypeData.ahaIconWhite && isColorLight"
        :name="slideTypeData.ahaIconWhite"
        :maintainColor="true"
      />

      <div
        :class="{
          'text-primary-90': active && !leftSide,
          'text-secondary-100': !active && !leftSide,
          'mt-0.5 text-sm': !leftSide,
          '-mt-0.5 text-xs': leftSide,
        }"
      >
        <span v-if="slideTypeData.label && leftSide">
          {{ slideTypeData.label + ': ' }}
        </span>
        <span>{{ slideTypeData.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { isColorLight } from '@/utils/color.utils'

export default {
  props: {
    slideType: {
      type: String,
      default: '',
    },
    childType: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    leftSide: {
      type: Boolean,
      default: true,
    },
    textColour: {
      type: String,
      default: '#313131',
    },
  },
  data() {
    return {
      slideTypesList: [],
      slideTypeData: {},
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('slideTypeList', ['getSlideTypeList']),
    ...mapGetters('themeModule', ['canViewThemeGallery']),
    isNewTypeAnswerIcon() {
      return this.slideTypeData
        && this.slideTypeData.ahaIconTest
        && this.isColorDark
    },
    isNewTypeAnswerIconWhite() {
      return this.slideTypeData
        && this.slideTypeData.ahaIconTestWhite
        && this.isColorLight
    },
    isColorLight() {
      if (this.canViewThemeGallery) return isColorLight(this.textColour)
      return this.textColour === '#ffffff'
    },
    isColorDark() {
      if (this.canViewThemeGallery) return !isColorLight(this.textColour)
      return this.textColour === '#313131'
    },
  },
  watch: {
    childType: {
      handler() {
        this.slideTypeData = this.getSlideTypeData()
      },
      deep: true,
    },
  },
  beforeUpdate() {
    this.slideTypeData = this.getSlideTypeData()
  },
  created() {
    this.slideTypesList = this.getListSlideTypes()
    this.slideTypeData = this.getSlideTypeData()
  },
  methods: {
    getListSlideTypes() {
      let slideTypesList = []

      const allTypeSections = this.getSlideTypeList
      allTypeSections.forEach((item) => {
        slideTypesList = slideTypesList.concat(item.slideTypes)
      })

      return slideTypesList
    },
    getSlideTypeData() {
      let slideTypeData = {}
      if (this.slideType) {
        const indexSlideType = this.slideTypesList.findIndex((item) => {
          if (this.childType) {
            return item.type === this.slideType && item.slideType === this.childType
          }

          return item.type === this.slideType
        })
        if (indexSlideType !== -1) {
          slideTypeData = this.slideTypesList[indexSlideType]
        }
      }

      return slideTypeData
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-slide-type-icon {
  @apply w-full text-xs leading-4 text-center flex-1 relative;
  display: flex;

  &.aha-slide-type-icon-left {
    @apply absolute;
    top: 27px;
    left: 0;

    .aha-icon-slide-wrapper {
      padding: 3px;
    }
  }
}

.aha-slide-type-icon.aha-slide-thumbnail-wrapper {
  .aha-icon-slide-wrapper {
    background-color: rgba(0,0,0,.38);
    border-radius: 5px;
    width: fit-content;
    color: #fff;
  }

  &.dark {
    .aha-icon-slide-wrapper {
      color: inherit;
      background-color: hsla(0,0%,100%,.9);
    }
  }
}
</style>
